import { useNavigate } from 'react-router'
import { useRemoteData } from '../../lib/RemoteData'
import {
  ArtikeldatenFile,
  BarcodeAndSonderpfand,
  CommonConfig,
  CrateFile,
  Modification,
  ShapeFile,
} from '../../domain/DTO'
import { API_HOST } from '../../lib'
import React from 'react'
import {
  ArticleDataTableWrapper,
  BarcodeCommonTableWrapper,
  CrateCommonTableWrapper,
  ShapeCommonTableWrapper,
} from './AssortmentDatabase'

type CommonAssortmentDatabaseProps = {
  common: CommonConfig
  initialTab?: string
}

export const CommonAssortmentDatabase = ({ common, initialTab }: CommonAssortmentDatabaseProps) => {
  const navigate = useNavigate()
  const commonId = common.commonAssortmentId
  const { data: barcode } = useRemoteData<BarcodeAndSonderpfand>(`${API_HOST}/v1/assortment/${commonId}/BARCODE`)
  const { data: commonBarcode, refresh: refreshBarcode } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/common/${commonId}/BARCODE/modifications`,
  )

  const { data: shape } = useRemoteData<ShapeFile>(`${API_HOST}/v1/assortment/${commonId}/SHAPE`)
  const { data: commonShape, refresh: refreshShape } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/common/${commonId}/SHAPE/modifications`,
  )

  const { data: crate } = useRemoteData<CrateFile>(`${API_HOST}/v1/assortment/${commonId}/CRATE`)
  const { data: commonCrate, refresh: refreshCrate } = useRemoteData<Modification[]>(
    `${API_HOST}/v1/common/${commonId}/CRATE/modifications`,
  )

  const { data: artikeldaten } = useRemoteData<ArtikeldatenFile>(`${API_HOST}/v1/assortment/${commonId}/ARTIKELDATEN`)

  const availableTypes = [
    common.shapeFileStream ? 'Shape' : '',
    common.barcodeFileStream ? 'Barcode' : '',
    common.crateFileStream ? 'Crate' : '',
    common.artikeldatenFileStream ? 'Artikeldaten' : '',
  ].filter((t) => t !== '')

  const getTabFromParam = (param?: string) => {
    if (!param) return null
    return availableTypes.find((t) => t.toLowerCase() === param.toLowerCase())
  }

  const activeTab = getTabFromParam(initialTab) || availableTypes[0]

  return (
    <div>
      <div className="tabs w-6/12">
        {availableTypes.map((type) => {
          return (
            <button
              key={type}
              className={`tab ${activeTab === type ? 'active' : ''}`}
              onClick={() => {
                navigate(`/common-assortment/${commonId}/${type.toLowerCase()}`)
              }}
            >
              {type}
            </button>
          )
        })}
      </div>
      {activeTab === 'Shape' && (
        <ShapeCommonTableWrapper
          config={'Common'}
          shape={shape}
          common={commonShape}
          commonId={commonId}
          refresh={refreshShape}
        />
      )}
      {activeTab === 'Barcode' && (
        <BarcodeCommonTableWrapper
          config={'Common'}
          barcode={barcode}
          common={commonBarcode}
          commonId={commonId}
          refresh={refreshBarcode}
        />
      )}
      {activeTab === 'Crate' && (
        <CrateCommonTableWrapper
          config={'Common'}
          crate={crate}
          common={commonCrate}
          commonId={commonId}
          refresh={refreshCrate}
        />
      )}
      {activeTab === 'Artikeldaten' && <ArticleDataTableWrapper artikeldaten={artikeldaten} />}
    </div>
  )
}
